import { render, staticRenderFns } from "./hzmb-form.vue?vue&type=template&id=4fdf4e35&scoped=true&"
import script from "./hzmb-form.vue?vue&type=script&lang=js&"
export * from "./hzmb-form.vue?vue&type=script&lang=js&"
import style0 from "./hzmb-form.vue?vue&type=style&index=0&id=4fdf4e35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdf4e35",
  null
  
)

export default component.exports